import { Extension } from 'tiptap';
import { EditorView } from 'prosemirror-view';
import { EditorState, PluginKey, Plugin } from 'prosemirror-state';

export default class SelectionChangePlugin extends Extension {
  options = { onSelectionChange: () => undefined };

  constructor(options = { onSelectionChange: () => undefined }) {
    super(options);
    this.options = options;
  }

  get plugins(): Plugin[] {
    return [
      new Plugin({
        key: new PluginKey('selection_change'),
        view: () => {
          return {
            update: (view: EditorView, prevState: EditorState) => {
              if (
                prevState &&
                prevState.doc.eq(view.state.doc) &&
                prevState.selection.eq(view.state.selection)
              ) {
                return;
              }

              this.options.onSelectionChange();
            },
          };
        },
      }),
    ];
  }
}
